import user_icon from 'PMDB/assets/images/icons/icon_user_01.svg';
import lock_icon from 'PMDB/assets/images/icons/icon_login_01.svg'

export const LINK = 'link';
export const BREAKLINE = 'breakline';
export const HEADLINE = "headline";
export const LINK_BTN = 'linkBtn';

export const SIGNUP_ITEMS = [
    { name: "email", label: "Email", intl: "auth.email", type: "email", placeholder: "you@example.com" },
    { name: "username", label: "Username", intl: "auth.username", type: "text", placeholder: "johndoe" },
    { name: "fullname", label: "Full Name", intl: "auth.fullname", type: "text", placeholder: "John Doe" },
    { name: "password", label: "Password", intl: "auth.password", type: "password", placeholder: "**********" },
];

export const SIGNUP_TDK_ITEMS = [
    { name: "firstname", label: "Firstname", intl: "auth.firstname", type: "text", isRequired: true },
    { name: "lastname", label: "Lastname", intl: "auth.lastname", type: "text" },
    { name: "email", label: "Email", intl: "auth.email", type: "email", isRequired: true, rules: { isEmail: true } },
    { name: "company", label: "Company", intl: "auth.company", type: "text", isRequired: true },
    { name: "department", label: "Department", intl: "auth.department", type: "text", isRequired: true },
    { name: "street", label: "Street", intl: "auth.street", type: "text", isRequired: true },
    { name: "city", label: "City", intl: "auth.city", type: "text", isRequired: true },
    { name: "zipcode", label: "ZipCode", intl: "auth.zipcode", type: "text", isRequired: true },
    { name: "country", label: "Country", intl: "auth.country", type: "text", isRequired: true },
];

export const SIGNUP_TDK_SUBTXT_ITEMS = [
    { name: "signup_subtxt1", intl: "auth.signup.subtxt1", type: "text" },
    { name: "signup_subtxt2", intl: "auth.signup.subtxt2", type: "text" },
    // { name: "subtxt3", intl: "auth.subtxt3", type: "text" },
];

export const SIGNIN_ITEMS = [
    { name: "username", intl: "auth.username", type: "text", placeholder: "johndoe", icon: user_icon, isRequired: true },
    { name: "password", intl: "auth.password", type: "password", placeholder: "**********", icon: lock_icon, isRequired: true },
];


export const SIGNIN_TDK_BOTTOM_ITEMS = [
    {
        name: "signin_forgot", intl: "page.auth.link.forgot",
        link: `mailto:tdk-picturepool@digitaspixelpark.com?subject=PicturePool password reset`,
        before: "auth.signin.contact.before",
        after: "auth.signin.contact.after"
    },
];


export const SIGNIN_BOTTOM_ITEMS = [
    { name: "signin_register", intl: "page.auth.link.register", isRegister: true },
    { name: "signin_forgot", intl: "page.auth.link.forgot", isForgot: true },
];


export const SIGNIN_TDK_SUBTXT_ITEMS = [
    { name: "signin_subtxt1", intl: "auth.signin.subtxt1", type: "text" },
    { name: "signin_subtxt2", intl: "auth.signin.subtxt2", type: "text" },
    {
        name: "signin_subtxt3", intl: "auth.signin.subtxt3", type: "linkBtn",
        isRegister: true,
        before: "auth.signin.subtxt3.before",
        after: "auth.signin.subtxt3.after"
    },
];


export const SIGNIN_TDK_INFO_ITEMS = [
    { name: "useofpicture", intl: "auth.signin.useofpicture", type: "headline" },
    { name: "signin_info1", intl: "auth.signin.info1", type: "text" },
    { name: "signin_info2", intl: "auth.signin.info2", type: "text" },
    { name: "signin_info3", intl: "auth.signin.info3", type: "text" },
    { name: "breakline", type: "breakline" },
    { name: "signin_info4", intl: "auth.signin.info4", type: "text" },
    { name: "breakline", type: "breakline" },
    { name: "signin_info5", link: "Felix.Mechernich@tdk.com", intl: "auth.signin.info5", type: "link" },
    { name: "signin_info6", link: "Elke.Herrnbeck@tdk.com", intl: "auth.signin.info6", type: "link" },
];
